const PAY_LATER_MIN_VALUE = 10000;

const PAY_LATER_AMOUNT = 5000;

const PAY_LATER_PERCENTAGE = 2 / 100;

const PAYMENT_METHOD = {
  ONLINE: "online",
  PAY_LATER: "pay_later",
};

const getLabel = (
  status: (typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD],
) => {
  switch (status) {
    case PAYMENT_METHOD.ONLINE:
      return "Online";

    case PAYMENT_METHOD.PAY_LATER:
      return "Cash on Delivery";
  }
};

export {
  PAYMENT_METHOD,
  PAY_LATER_MIN_VALUE,
  PAY_LATER_AMOUNT,
  PAY_LATER_PERCENTAGE,
  getLabel,
};
